import { gql } from '@apollo/client';

export default gql`
  mutation AddAssistanceToBooking(
    $bookingReference: String!
    $input: [AssistanceInput!]!
    $applySalesRestrictionOverrides: Boolean = false
  ) {
    addAssistanceToBooking(
      bookingReference: $bookingReference
      input: $input
      applySalesRestrictionOverrides: $applySalesRestrictionOverrides
    ) {
      reference
      totalPriceToBePaid
      outboundExtras {
        itemRef
        passengerId
        type
        code
        cancelled
      }
      inboundExtras {
        itemRef
        passengerId
        type
        code
        cancelled
      }
    }
  }
`;
